module.exports = __webpack_public_path__ + "assets/img/triple_open_r.49c2bf03.svg";